__turbopack_context__.v({
  "avatarContainer": "PersonModal-module-scss-module__5kbp8a__avatarContainer",
  "avatarImage": "PersonModal-module-scss-module__5kbp8a__avatarImage",
  "avatarOverlay": "PersonModal-module-scss-module__5kbp8a__avatarOverlay",
  "blocksBackgroundColor": "PersonModal-module-scss-module__5kbp8a__blocksBackgroundColor",
  "blocksFontColor": "PersonModal-module-scss-module__5kbp8a__blocksFontColor",
  "classroomButton": "PersonModal-module-scss-module__5kbp8a__classroomButton",
  "classroomButtonContainer": "PersonModal-module-scss-module__5kbp8a__classroomButtonContainer",
  "deleteButton": "PersonModal-module-scss-module__5kbp8a__deleteButton",
  "editPopup": "PersonModal-module-scss-module__5kbp8a__editPopup",
  "editable": "PersonModal-module-scss-module__5kbp8a__editable",
  "linkToSite": "PersonModal-module-scss-module__5kbp8a__linkToSite",
  "secondaryNavBackgroundColor": "PersonModal-module-scss-module__5kbp8a__secondaryNavBackgroundColor",
  "spanCreate": "PersonModal-module-scss-module__5kbp8a__spanCreate",
  "spanCreateNew": "PersonModal-module-scss-module__5kbp8a__spanCreateNew",
  "themeBackgroundColor": "PersonModal-module-scss-module__5kbp8a__themeBackgroundColor",
  "themeFontColor": "PersonModal-module-scss-module__5kbp8a__themeFontColor",
  "tooltip": "PersonModal-module-scss-module__5kbp8a__tooltip",
  "uploading": "PersonModal-module-scss-module__5kbp8a__uploading",
});
